// BarChart.js - Horizontal/vertical bar charts using Recharts
import React from 'react';
import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'];

const BarChart = ({
  data,
  xKey = 'name',
  bars = [],
  height = 300,
  layout = 'vertical',
  showGrid = true,
  showLegend = false,
  colorByIndex = false,
  formatXAxis,
  formatYAxis,
  formatTooltip
}) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-gray-400">
        No data available
      </div>
    );
  }

  const isHorizontal = layout === 'horizontal';

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsBarChart
        data={data}
        layout={layout}
        margin={{ top: 5, right: 20, left: isHorizontal ? 10 : 80, bottom: 5 }}
      >
        {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="#374151" />}

        {isHorizontal ? (
          <>
            <XAxis
              dataKey={xKey}
              stroke="#9CA3AF"
              tick={{ fill: '#9CA3AF', fontSize: 11 }}
              tickFormatter={formatXAxis}
              angle={-45}
              textAnchor="end"
              height={60}
            />
            <YAxis
              stroke="#9CA3AF"
              tick={{ fill: '#9CA3AF', fontSize: 12 }}
              tickFormatter={formatYAxis}
            />
          </>
        ) : (
          <>
            <XAxis
              type="number"
              stroke="#9CA3AF"
              tick={{ fill: '#9CA3AF', fontSize: 12 }}
              tickFormatter={formatXAxis}
            />
            <YAxis
              type="category"
              dataKey={xKey}
              stroke="#9CA3AF"
              tick={{ fill: '#9CA3AF', fontSize: 11 }}
              width={75}
              tickFormatter={(value) => value?.length > 12 ? `${value.slice(0, 12)}...` : value}
            />
          </>
        )}

        <Tooltip
          contentStyle={{
            backgroundColor: '#1F2937',
            border: '1px solid #374151',
            borderRadius: '8px',
            color: '#F3F4F6'
          }}
          labelStyle={{ color: '#F3F4F6' }}
          formatter={formatTooltip}
        />

        {showLegend && <Legend wrapperStyle={{ color: '#9CA3AF' }} />}

        {bars.map((bar, barIndex) => (
          <Bar
            key={bar.dataKey}
            dataKey={bar.dataKey}
            name={bar.name || bar.dataKey}
            fill={bar.color || COLORS[barIndex % COLORS.length]}
            radius={[4, 4, 4, 4]}
          >
            {colorByIndex && data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
};

export default BarChart;
